// themeConfig.ts
import { ThemeConfig } from "antd/es/config-provider/context";
import esES from "antd/locale/es_ES";
import { Colors } from "../constants/Colors";
import { theme } from "antd";
const { darkAlgorithm } = theme;

export const themeLocale = esES;

export const themeConfig: ThemeConfig = {
  algorithm: darkAlgorithm,
  token: {
    fontFamily: "Inter, Geist, 'Geist Fallback', system-ui, sans-serif",
    colorText: "white",
    colorPrimary: Colors.primary,
  },
  components: {
    Menu: {
      itemSelectedColor: Colors.textPrimary,
      colorBgElevated: "#1E40AF",
    },

    Segmented: {
      trackPadding: 24,
    },
    Input: {
      colorPrimary: Colors.primary,
      colorBorder: Colors.borderInputs,
      colorTextPlaceholder: Colors.textPlaceholder,
      algorithm: true,
      paddingBlock: 12,
      paddingInline: 16,
      borderRadius: 12,
      lineWidth: 1,
    },
    DatePicker: {
      colorPrimary: Colors.primary,
      colorBorder: Colors.borderInputs,
      colorTextPlaceholder: Colors.textPlaceholder,
      algorithm: true,
      paddingBlock: 12,
      paddingInline: 16,
      borderRadius: 12,
      lineWidth: 1,
    },
    InputNumber: {
      colorPrimary: Colors.primary,
      colorBorder: Colors.borderInputs,
      colorTextPlaceholder: Colors.textPlaceholder,
      algorithm: true,
      paddingBlock: 12,
      paddingInline: 16,
      borderRadius: 12,
      lineWidth: 1,
    },
    Select: {
      colorPrimary: Colors.primary,
      colorBorder: Colors.borderInputs,
      colorTextPlaceholder: Colors.textPlaceholder,
      algorithm: true,
      borderRadius: 12,
      controlHeight: 48,
      lineWidth: 1,
    },
    Button: {
      borderRadius: 12,
      defaultHoverBorderColor: undefined,
      defaultHoverBg: undefined,
      defaultShadow: undefined,
      defaultHoverColor: undefined,
      primaryColor: "#060d06",
      fontWeight: 700,
    },
    Table: {
      headerBg: "#070B0E",
      headerColor: "#FFFFFF",
      borderColor: "#1A2328",
      rowHoverBg: "#0D1519",
      colorBgContainer: "#04080A",
      headerSplitColor: "#1A2328",
    },

    Tag: {
      borderRadiusSM: 999,
      borderRadius: 999,
      borderRadiusLG: 999,
    },
    Popconfirm: {},
  },
};
